import React from 'react';
import Loader from 'react-loaders';
import { Button, ModalBody } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './DocumentSignedFrame.scss';
const DocumentSignedFrame = () => {
    const header = 'Confirming Document Execution!';
    const text =
        "Thank you for executing the document. We are awaiting Sign Request's confirmation of the successfully executed document. This should only take a minute or so. We appreciate your patience.";

    return (
        <Rodal
            visible={true}
            showMask={false}
            width="400"
            showCloseButton={false}
            className="document-signed-frame">
            <ModalBody height="425px">
                <div className="text-center loader-wrapper">
                    <Loader type="ball-scale-multiple" active />
                </div>
                <h3 className="text-center">{header}</h3>
                <span className="text-center">{text}</span>
                <div className="text-center" style={{ marginTop: '10px' }}>
                    <Button type="button" color="success">
                        Refresh
                    </Button>
                </div>
            </ModalBody>
        </Rodal>
    );
};
export default DocumentSignedFrame;
